/* @HEADER
 * @version 1.0.1627 | 2026-09-20
 * @purpose The host of the space-delete question (ZVX-DEV-5637): resolves the dialog's copy from the messages layer so the pending-delete state can stay with the handler one level up, where MessagesProvider is not yet mounted. Out of App.tsx so the host is a file with its own proof (ZVX-DEV-6144, App.tsx-by-meaning S5).
 * @sidecar SpaceDeleteDialogHost.tsx.header.md
 * @layer app | @hex adapter | @ctx board
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-6144, ZVX-DEV-5637

import { SpaceDeleteDialog, type SpaceDeleteDialogProps } from './SpaceDeleteDialog'
import { useMessages } from '../shared/i18n/useMessages'

export type SpaceDeleteDialogHostProps = Omit<SpaceDeleteDialogProps, 'messages'>

/**
 * ZVX-DEV-5637 — the dialog's copy comes from the messages layer, and
 * `MessagesProvider` is mounted INSIDE the component that owns the pending
 * delete. A host one level down is what lets the state stay where the handler
 * is while the copy is resolved where the provider is.
 */
export function SpaceDeleteDialogHost(props: SpaceDeleteDialogHostProps) {
  const m = useMessages()
  return <SpaceDeleteDialog {...props} messages={m.spaceDelete} />
}
